export const PH_LOGGED_IN = 'Logged in';
export const PH_LOGOUT = 'Logout';
export const PH_SIDEBAR_CLICKED = 'Sidebar Clicked';
export const PH_CLASS_CLICKED = 'Class Clicked';
export const PH_LOGIN_WITH_EMAIL = 'Login With Email';
export const PH_JOIN_CLASS = 'Join Class Clicked';
export const PH_TEACHER_CLASS_DETAILS_TAB_CHANGE = 'Teacher Class Tab Change';
export const PH_STUDENT_CLASS_DETAILS_TAB_CHANGE = 'Student Class Tab Change';
export const PH_NEW_CLASS_ADDED = 'New Class Added';
export const PH_CLASS_UPDATED = 'Class Updated';
export const PH_ADD_RESOURCE_CLICK = 'Add Resource Click';
export const PH_ADD_TEST_CLICK = 'Add Test Click';
export const PH_ADD_ASSIGNMENT_CLICK = 'Add Assignment Click';
export const PH_ADD_STUDENT_CLICK = 'Add Student Click';
export const PH_ADD_TEACHER_CLICK = 'Add Teacher Click';
export const PH_OFFLINE_ATTENDANCE_CLICK = 'Offline Attendance Click';
export const PH_NEW_ATTENDANCE_CREATED = 'New Attendance Created';
export const PH_NEW_TEST_CREATED = 'New Test Created';
export const PH_NEW_ASSIGNMENT_CREATED = 'New Assignment Created';
export const PH_OFFER_CLICK = 'Offer Click';
export const PH_OFFER_COUPON_COPIED = 'Offer Coupon Copied';
export const PH_ADD_EVENT_CLICKED = 'Add Calendar Event Click';
export const PH_NEW_EVENT_ADDED = 'New Calendar Event Added';
export const PH_EVENT_UPDATED = 'Event Updated';
export const PH_DISCOVER_CATEGORY_CLICK = 'Discover Category Select';
export const PH_FEED_CREATE = 'Feed Create';
export const PH_CLASS_JOIN_CLICK = 'Class Join Click';
export const PH_CLASS_JOIN = 'Class Joined';
